import { MDBBtn, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import React, { forwardRef, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { creatHuntGroup, getMisc } from "../../../apiclients/streamsapi_bridge";

const AddHuntGroup = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const [autoext, setAutoext] = useState(true);
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [checkAvailbilityTxt, setCheckAvailbilityTxt] = useState("");
  // const [isloading, setIsloading] = useState(false);
  // const [error, setError] = useState({});
  const thName = useRef();
  const extRef = useRef();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    formState,
    clearErrors,
  } = useForm({
    defaultValues: {
      name: "",
      extension: "",
    },
  });
  const { errors, isDirty } = formState;

  // useEffect(() => {
  //   setTimeout(() => {
  //     thName.current.focus();
  //   }, 1000);
  // }, []);

  async function checkAvailability(e) {
    if (e.target.value.trim() == "") {
      return;
    }
    setextCheckFlag(1);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }

  const onsubmit = async (data) => {
    let updates = {};
    if (isDirty) {
      setCheckAvailbility(false);
      updates = {
        reqid: 8,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        name: data.name,
        extension: parseInt(data.extension),
      };
      console.log(updates);
      props.setIsloading(true);
      let saverep = await creatHuntGroup(updates);
      setTimeout(() => {
        props.setIsloading(false);
      }, 2000);
      let saverepeMsg = await saverep.json();
      console.log(saverepeMsg);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        if ( props.destination && props.destination  === "callflow"){
          localStorage.setItem(
            "s_message",
            "Group " + data.name + " created successfully. Please refresh the page to use the newly created group."
          );
        } else {
          localStorage.setItem(
            "s_message",
            "Group " + data.name + " created successfully."
          );
        }

        sessionStorage.setItem("hgroup_updated", true);
        props.onClose();
        if (props.onSuccess) {
          props.onSuccess({...saverepeMsg, name:data.name , flag : "hunt" , extension : data?.extension}, props.tnode);
          return;
        } else {
          window.location.href = "/huntgroup";
        }
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        }else {
          localStorage.setItem("f_message",saverepeMsg.message);
          window.location.href = "/huntgroup";
        }
      }
    }
  };

  return (
    <>
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
      <div>
        <div className="tel-numbers">
          <strong>{t("HuntGroupName")}</strong>
        </div>
        <form>
          <div className="form pt-1">
            <input
              type="text"
              maxLength={20}
              className="form-control"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && (
              <p className="text-danger">{errors.name.message}</p>
            )}
          </div>
          <div className="row">
            <div className="pt-2">
              <div className="tel-numbers mt-2">
                <strong>{t("extension")}</strong>
              </div>

              <input
                type="text"
                maxLength={5}
                className="w-100 form-control"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                {...register("extension", {
                  setValueAs: (value) => Number(value),
                  required: "Extension is required",
                  minLength: {
                    value: 3,
                    message: "Extension must be at least 3 characters",
                  },
                  maxLength: {
                    value: 5,
                    message: "Extension must not exceed 5 characters",
                  },
                })}
                onChange={(e) => {
                  e.preventDefault();
                  if (!/^\d+$/.test(e.target.value)) {
                    setCheckAvailbility(false);
                    setError("extension", { message: "Extension is required and must be numeric" });
                  } else if (e.target.value.length >= 3 && e.target.value.length <= 5) {
                    if (e.target.value.charAt(0) === "0") {
                      setCheckAvailbility(false);
                      setError("extension", { message: "An extension cannot begin with zero(0)" });
                    } else {
                      checkAvailability(e);
                    }
                  } else {
                    setCheckAvailbility(false);
                    clearErrors("extension");
                  }
                }}
              />
              {errors.extension && (
                <>
                  {!checkAvailbility && (
                    <>
                      <p className="text-danger">{errors.extension.message}</p>
                    </>
                  )}

                  {checkAvailbility && (
                    <p style={{ color: "Green" }} className="clr-red">
                      {errors.extension.message}
                    </p>
                  )}
                </>
              )}
            </div>
            {/* <div className="col-6 pt-2">
              <div className="tel-numbers mt-4 pt-3">
                {!autoext && (
                  <a href="#" onClick={(e) => checkAvailability(e)}>
                    Check Availabiliy
                  </a>
                )}
              </div>
            </div> */}
          </div>
          <br />

          <div style={{ display: "none" }}>
            <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
              {t("add")}</button>
          </div>

          {/* <MDBModalFooter>
            <MDBBtn color="secondary" onClick={props.onClose}>
              {t("close")}
            </MDBBtn>
            <MDBBtn
              onClick={(e) => {
                e.preventDefault();
                handleSubmit(onsubmit)();
              }}
            >
              {t("add")}
            </MDBBtn>
          </MDBModalFooter> */}
        </form>
      </div>
    </>
  );
});

export default AddHuntGroup;
